function initFeaturedLogoSlider() {

  const sliders = document.querySelectorAll('.featured-logo-slider');

  if (!sliders.length) return;

  sliders.forEach((slider) => {

    if (slider.classList.contains('is-initialized')) return;

    new Splide(slider, {
      type: 'slide',
      perPage: 6,
      perMove: 1,
      gap: '20px',
      arrows: false,
      pagination: false,
      drag: false,

      breakpoints: {
        1199: {
          perPage: 5,
          drag: true,
          autoplay: true,
          interval: 3000,
          speed: 1200
        },
        990: {
          perPage: 3,
          drag: true,
        },
        600: {
          perPage: 2,
          drag: true,
        }
      }
    }).mount();

  });

}

document.addEventListener('DOMContentLoaded', initFeaturedLogoSlider);
document.addEventListener('shopify:section:load', initFeaturedLogoSlider);
document.addEventListener('shopify:block:select', initFeaturedLogoSlider);